import Alert from 'antd/lib/alert';
import Button from 'antd/lib/button';
import * as PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

import { EditorField } from 'modules/forms';

import { getPartnersValueKey } from '../../utils';

const PartnersForm = ({ handleSubmit, submitting, error, language }) => {
    const intl = useIntl();

    return (
        <form onSubmit={e => handleSubmit(e, language)}>
            {error && <Alert type="error" message={intl.formatMessage({ id: error })} />}
            <EditorField name={getPartnersValueKey(language)} />
            <Button loading={submitting} htmlType="submit" type="primary">
                <FormattedMessage id="partners.form.button" />
            </Button>
        </form>
    );
};

PartnersForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    error: PropTypes.string,
    language: PropTypes.string.isRequired,
};

PartnersForm.defaultProps = {
    error: null,
};

export default PartnersForm;
